import { Inject, Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { AccidentsMetaDataItemNames, WageExpenseEntity } 
         from '../meta-data/accidents-meta-data.service';
import { DwMetaDataRoutingService, DwActionResult, DwMenuActionType, DwAction, DwActionType, DwMdFormActionResult, DwMdFormActionHandler,
         DwMdFormActionState, DwQueryHelper, DwModalConfig, DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken,
         DwEventService } 
         from '@devwareapps/devware-cap';

@DwAction({
  keyName: 'Workers_Comp_Edit_Wage_Expense',
  display: 'Workers Comp Edit Wage Expense',
  actionType: DwActionType.gridRowAction,
  isGlobal: false,
  parentItemName: [ AccidentsMetaDataItemNames.WageExpense ],
  defaultButtonConfig: {
    buttonClass: 'btn-sm btn-success mr-1 mt-1',
    buttonText: 'Edit',
    iconClass: 'dw-icon-edit-grid'
  },
  defaultConfirmConfig: {
    showDialogConfig: true
  },
  defaultSecurityConfig: { requireCanUpdate: false },
})
@Injectable()
export class WageExpenseEditActionService implements DwMdFormActionHandler {

  constructor(
    private dwEventService: DwEventService,
    private metaDataRoutingService: DwMetaDataRoutingService,
    private dwModalService: DwModalService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService
  ) { }

  EDIT_TOPIC = 'EDIT-WAGE-EXPENSE';
  DELETE_TOPIC = 'DELETE-WAGE-EXPENSE';
  handleAction(formActionState: DwMdFormActionState): Observable<DwActionResult> {
    const isDelete = formActionState.actionPreference.actionDisplay == 'Delete';
    const topic = isDelete ? this.DELETE_TOPIC : this.EDIT_TOPIC;
    this.dwEventService.publishEvent(topic, formActionState.data);
    return null;
  }
}
